import IJobSection from "../../interfaces/IJobSection";
import { BoxHeader } from "./box-header";
import * as React from "react";
import { Button } from "reactstrap";
import { ll_url } from "../../../../utils/tools";
import { ViewerLink } from "../viewer-link";
import { Section } from "./section";

export function SectionStructure3d({section}: {section: IJobSection}) {
  return (
    <Section section={section} style={{marginTop: '1rem'}}>
      <a href={"https://molstar.org/"} target="_blank" className="ll-logo-link">
        <img src={ll_url('/images/result/molstar.png')} style={{
          maxHeight: 'calc(1.2rem + 0.5rem + 5px)',  // section name font size + body top margin + header bottom padding
          height: '1.3rem',
        }} />
      </a>
      <BoxHeader section={section}/>
      <div className="ll-section-body">
        <div style={{ fontSize: '1.1rem', textAlign: 'center', marginBottom: '1rem' }}>
          <ViewerLink>
            <Button>Open structure viewer</Button>
          </ViewerLink>
        </div>
      </div>
    </Section>
  )
}
